import React from "react"
import { ContentfulContentBaseProps } from "../types"
import CodeSnippet from "@components/CodeSnippet"

interface ContentfulCodeSnippetProps extends ContentfulContentBaseProps {}

const ContentfulCodeSnippet: React.FC<ContentfulCodeSnippetProps> = ({
  blockId,
  cleanupId,
  code,
}) => {
  return (
    <CodeSnippet
      blockId={blockId}
      cleanupId={cleanupId}
      code={code?.code || ""}
    />
  )
}

export default ContentfulCodeSnippet
